<template>
    <el-dialog
            width="650px"
            :title="'高级查询'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item v-if="!hasSearchColumns" label="关键字">
                <el-input v-model="searchKey" placeholder="关键字" clearable></el-input>
            </el-form-item>
            <el-form-item v-for="(item,i) in searchColumnList" :key="i" :label="item.title">
                <el-date-picker class="month-choose"
                                v-model="item.value"
                                type="daterange"
                                v-if="item.dataType===1 || item.dataType===6"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="截止日期">
                </el-date-picker>
                <el-select v-else-if="item.dataSourceType===2" v-model="item.value" filterable placeholder="请选择">
                    <el-option
                            v-for="dictItem in item.dataSourceDictNodes"
                            :key="dictItem.id"
                            :label="dictItem.text"
                            :value="dictItem.id">
                    </el-option>
                </el-select>
                <el-input v-else v-model="item.value" :placeholder="item.title" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">查询</el-button>
    </span>
    </el-dialog>
</template>
<script>
    // import {parseDayPickValueStr} from '@/utils/index.js'

    export default {
        data() {
            return {
                visible: false,
                hasSearchColumns: false,
                ruleId: '',
                searchKey: '',
                searchColumnList: [],
            }
        },
        methods: {
            getSearchList(ruleId) {
                this.$http({
                    url: `/api/dataset/busi/getSearchColumnInfo?ruleId=${ruleId}`,
                    method: 'post',
                    baseURL: '',
                }).then(({data}) => {
                    this.searchColumnList = data.data ? data.data : []
                    this.hasSearchColumns = data.data && data.data.length > 0
                    if (this.hasSearchColumns) {
                        this.searchKey = ''
                    }
                })
            },
            init(ruleId) {
                this.ruleId = ruleId
                this.searchKey = ''
                this.getSearchList(ruleId)
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                })
            },
            dataFormSubmit() {
                this.visible = false
                let args = {
                    searchKey: this.searchKey === undefined ? '' : this.searchKey
                }
                for (var i = 0; i < this.searchColumnList.length; i++) {
                    let columnInfo = this.searchColumnList[i];
                    if (columnInfo.value === undefined) {
                        continue
                    }
                    if (columnInfo.dataType === 1 || columnInfo.dataType === 6) {
                        // let dateRange = parseDayPickValueStr(columnInfo.value)
                        // console.log('columnInfo', dateRange.from, dateRange.end)
                        // args[columnInfo.columnName + "_from"] = dateRange.from
                        // args[columnInfo.columnName + "_end"] = dateRange.end
                    } else {
                        args[columnInfo.columnName] = columnInfo.value
                    }
                }
                this.$emit('refreshDataList', args)
            }
        }
    }
</script>
